import { render, staticRenderFns } from "./department-staff-management.vue?vue&type=template&id=a6bd82a0&scoped=true"
import script from "./department-staff-management.vue?vue&type=script&lang=js"
export * from "./department-staff-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd82a0",
  null
  
)

export default component.exports